// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/@rsbuild+core@1.7.3/node_modules/@rsbuild/core/compiled/css-loader/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/@rsbuild+core@1.7.3/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-slim-l-activity-FQEg85 {
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
}

.auth-container-oG5GOU {
  cursor: default;
  border-radius: 16px;
  width: 400px;
}

.auth-container-oG5GOU .header-aIS6lK {
  color: #000;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  padding: 20px 25px;
  display: flex;
  position: relative;
}

.auth-container-oG5GOU .header-aIS6lK .close-btn-WcsCjd {
  position: absolute;
  right: 20px;
}

.auth-container-oG5GOU .content-Bw_gd9 {
  padding: var(--wg-login-content-padding, 0 40px 40px);
}

.auth-container-oG5GOU .content-Bw_gd9.is-mobile-Pe7vtk {
  padding: var(--wg-login-content-padding-mobile, 0 40px);
}
`, "",{"version":3,"sources":["webpack://./root/packages/login/src/components/AuthContainer/index.module.less","webpack://./src/components/AuthContainer/index.module.less"],"names":[],"mappings":"AAAA;ECCE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uDAAuD;AACzD","sourcesContent":["/* font start */\n.font-slim-l-activity {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22px;\n}\n/* font end */\n.auth-container {\n  width: 400px;\n  border-radius: 16px;\n  cursor: default;\n}\n.auth-container .header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 70px;\n  padding: 20px 25px;\n  color: black;\n}\n.auth-container .header .close-btn {\n  position: absolute;\n  right: 20px;\n}\n.auth-container .content {\n  padding: var(--wg-login-content-padding, 0 40px 40px);\n}\n.auth-container .content.is-mobile {\n  padding: var(--wg-login-content-padding-mobile, 0 40px);\n}\n",".font-slim-l-activity {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.auth-container {\n  cursor: default;\n  border-radius: 16px;\n  width: 400px;\n}\n\n.auth-container .header {\n  color: #000;\n  justify-content: space-between;\n  align-items: center;\n  height: 70px;\n  padding: 20px 25px;\n  display: flex;\n  position: relative;\n}\n\n.auth-container .header .close-btn {\n  position: absolute;\n  right: 20px;\n}\n\n.auth-container .content {\n  padding: var(--wg-login-content-padding, 0 40px 40px);\n}\n\n.auth-container .content.is-mobile {\n  padding: var(--wg-login-content-padding-mobile, 0 40px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"font-slim-l-activity": `font-slim-l-activity-FQEg85`,
	"fontSlimLActivity": `font-slim-l-activity-FQEg85`,
	"auth-container": `auth-container-oG5GOU`,
	"authContainer": `auth-container-oG5GOU`,
	"header": `header-aIS6lK`,
	"close-btn": `close-btn-WcsCjd`,
	"closeBtn": `close-btn-WcsCjd`,
	"content": `content-Bw_gd9`,
	"is-mobile": `is-mobile-Pe7vtk`,
	"isMobile": `is-mobile-Pe7vtk`
};
export default ___CSS_LOADER_EXPORT___;
